<template>
  <div class="personal-video">
    <div class="title">{{ props.title }}</div>
    <video
      controls
      :src="videoUrl"
      poster="https://peach.blender.org/wp-content/uploads/title_anouncement.jpg?x11217"
      width="1080"
    >
      您的浏览器不支持 video 标签。
    </video>
  </div>
</template>
<script setup>
import { defineProps, onBeforeMount, ref } from 'vue'
const props = defineProps({
  title: {
    type: String,
    require: true
  }
})
const videoUrl = ref('https://sf1-cdn-tos.huoshanstatic.com/obj/media-fe/xgplayer_doc_video/mp4/xgplayer-demo-360p.mp4')
onBeforeMount(() => {
  // TODO axios
  // videoUrl.value = res.data
})
</script>
<style scoped>
.personal-video {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
  padding-bottom: 30px;
}
.title {
  font-size: 18px;
  font-weight: 900;
  color: #333333;
  border-bottom: 2px solid #333333;
  width: fit-content;
}
</style>
